/* tslint:disable */

// Google Anlytics
//import ReactGA from 'react-ga';
import { GAnalytics } from "@ktr/ktr-materialui-react"

import Configuration from '../config/Config';

export type LayoutResult = {
  title: string;
  coolerName: string;
  ranking: string;

  //manufacturer: string;
  //type: string;
  //plateType: string;
  //plateMaterial: string;
  //reachedHeatLoad: string;

  temperatureIn1: number;
  temperatureIn2: number;

  temperatureOut1: number;
  temperatureOut2: number;

  volumeFlow1: number;
  volumeFlow2: number;

  heatFlow: number;

  pressureDrop1: number;
  pressureDrop2: number;

  geo: {
    screwThreadA: string;
    screwThreadB: string;
    a: number;
    b: number;
    c: number;
    d: number;
    e: number;
    f: number;
  };

  order: {
    pheName: string;
    size: number;
    partNoCooler: string;
    partNoHolder: string;
  };

  n_plates: number;
  n_channel_hot: number;
  n_channel_cold: number;

  width: number;
  height: number;
  price: number;

  urlCatalog: string;
  urlAssembly: string;
  urlPdf: string;
}


//export type LayoutInput = {
export interface LayoutInput {
  phename: string;

  operation: string;
//  plateType: string; 
//  plateMaterial: string;
//  coCurrent: boolean;

  inTempSide1: string;
  volumeFlowSide1: string;
//  fluidConcSide1: string;
  fluidSide1: string;

  inTempSide2: string; 
  volumeFlowSide2: string;
//  fluidConcSide2: string;
  fluidSide2: string;
  
//  plateThickness: string;
//  fouling: string;
//  minNumberOfUnits: string;
//  maxNumberOfUnits: string;

//  numberOfPassesSide1: string;
//  numberOfChannelsSide1: string;
//  channelType1: string;

//  numberOfPassesSide2: string;
//  numberOfChannelsSide2: string;
//  channelType2: string;

//  dissipatedHeat: string;
  heatDissipation: string;

  responseData: string;
}


// --------------------------------------------------------------------------------------------------------------------------------------------------
export function createUrlLayout(layoutInputData: LayoutInput, lang: string | undefined): string {
  const baseurl: string = Configuration.host + `/${layoutInputData.operation}`;
  if(lang === undefined) lang = 'en';
  const url: string = `${baseurl}?pheName=${layoutInputData.phename}&inTempSide1=${layoutInputData.inTempSide1}&volumeFlowSide1=${layoutInputData.volumeFlowSide1}&fluidSide1=${layoutInputData.fluidSide1}&inTempSide2=${layoutInputData.inTempSide2}&volumeFlowSide2=${layoutInputData.volumeFlowSide2}&fluidSide2=${layoutInputData.fluidSide2}&heatDissipation=${layoutInputData.heatDissipation}&lang=${lang}`;
  return url;
}  

export function createUrlPDF(urlPdfPara: string): string {
  const baseurl = Configuration.host + `/cooler/pdf`;
  const url: string = `${baseurl}${urlPdfPara}`;
  //const url: string = `${baseurl}?pheName=${layoutInputData.pheName}&inTempSide1=${layoutInputData.inTempSide1}&volumeFlowSide1=${layoutInputData.volumeFlowSide1}&fluidSide1=${layoutInputData.fluidSide1}&inTempSide2=${layoutInputData.inTempSide2}&volumeFlowSide2=${layoutInputData.volumeFlowSide2}&fluidSide2=${layoutInputData.fluidSide2}&heatDissipation=${layoutInputData.heatDissipation}`;
  return url;
}


/*
export function createUrlPDF(layoutInputData: LayoutInput): string {
  const baseurl = Configuration.host + `/cooler/pdf`;
  const url: string = `${baseurl}?pheName=${layoutInputData.pheName}&inTempSide1=${layoutInputData.inTempSide1}&volumeFlowSide1=${layoutInputData.volumeFlowSide1}&fluidSide1=${layoutInputData.fluidSide1}&inTempSide2=${layoutInputData.inTempSide2}&volumeFlowSide2=${layoutInputData.volumeFlowSide2}&fluidSide2=${layoutInputData.fluidSide2}`;
  return url;
}
*/

// --------------------------------------------------------------------------------------------------------------------------------------------------
export async function performFetch(url: string): Promise<LayoutResult[]> {
  var resRows: LayoutResult[] = [];

  // await-syntax:
  try {

    //
    GAnalytics.gaEvent('Cooler layout request', 'PHE cooler layout');

    //
    const response = await fetch(url);
    const responseData = await response.json();

    if(response.ok) {   // HTTP 200
      //
      if(Array.isArray(responseData)) {      // if operation is rate: many results, so we have an array (maybe empty)
        if(responseData !== undefined) {
          responseData.map(res => {
            return resRows.push(res);
          });
        }
      }
      else {
        resRows.push(responseData);         // if operation is performance: one or no result
      }
    }
    else {   // HTTP NOT 200
      //alert(responseData.message)           // TODO
      throw new Error(responseData.message);
    }
  }
  catch (e) {
    console.error(e);   // handle network errors (HTTP errors like 404 will NOT be handled here)
    throw new Error(e);
  }

  return resRows;
}


/*
// then-syntax: same as above async-await syntax, but not yet working (just for interest)
export async function performFetch(url: string): Promise<LayoutResult[]> {
  var resRows: LayoutResult[] = [];

  // then-syntax ??? (not working yet, just for interest):
  fetch(url)
    .then(response => response.json())    // response is a promise
    .then(responseData => {               // responseData is a promise
      resRows = [];
      if(Array.isArray(responseData)) {      // rate: also mehrere Ergebnisse (ist ein Array)
        if(responseData !== undefined) {
          responseData.map(res => {
            return resRows.push(res);
          });
        }
      }
      else {
        resRows.push(responseData);
      }
    })
    //.catch(err => {
    //  console.error(err) 
    //  return (new Promise<LayoutResult[]>((e) => { e = []; } ));           // has to be a promise
    //});

    return new Promise<LayoutResult[]>((resolve, reject) => {
      if(resRows === []) {
        reject(resRows);
      }
      else {
        resolve(resRows);
      }
    });
  }
*/  

/*
// --------------------------------------------------------------------------------------------------------------------------------------------------
let gaIsInitialized:boolean = false;
export function checkCookie(name: string) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) 
          return c.substring(nameEQ.length, c.length);
  }
  return null;
}


export function gaInit(cookiename: string) {
  var complianceCookie = checkCookie(cookiename);
  if(complianceCookie?.toLocaleLowerCase().includes("Analytics".toLocaleLowerCase())) {
    ReactGA.initialize('UA-65129143-4', {debug: false});
    ReactGA.pageview('/watercooler');  
    gaIsInitialized = true;
  }
  else {
    gaIsInitialized = false;
  }
}


export function gaEvent(action: string, category: string) {
  let cookiename = Configuration.cookiename;

  // check for complicance state, i.e. what has been selected on cookie-banner popup (user may select not to allow ga cookies): "Standard", "Analytics" or "None"
  var complianceCookie = checkCookie(cookiename);
  if(complianceCookie?.toLocaleLowerCase().includes("Analytics".toLocaleLowerCase())) {
    // if Analytics: initialize GA if not already done:
    if(gaIsInitialized === false) { gaInit(cookiename);  }
  
      //gtag('event', action, { 'event_category' : category, 'event_label' : label});
      ReactGA.event({category: category, action: action});  
      //ReactGA.event({category: 'User', action: 'Create an Account'});  
  }
  
  if(complianceCookie?.toLocaleLowerCase().includes("Standard".toLocaleLowerCase())) {
      // we do not have any standard cookies right now.
  }
}

export function initSalesViewer (cookieName: string) {
  var complianceCookie = checkCookie(cookieName);
  if((complianceCookie === null) || (complianceCookie === undefined)) return;
  if(complianceCookie.toLowerCase().includes("Marketing".toLowerCase())) {
      loadSalesViewer();
  }
}


function loadSalesViewer() {
  var strSalesViewerScript = "<script>!function(s,a,l,e,sv,i,ew,er){try{a=s[a]||s[l]||function(){throw\"no_xhr\"},sv=i=\"//salesviewer.org\",l=s.SV_XHR=function(d){return er=new a,er.onerror=function(){if(sv!=i)throw\"load_err\";" +
                             "sv=\"//www.salesviewer.com\",setTimeout(l.bind(null,d),0)},er.onload=function(){(s.execScript||s.eval).call(er,er.responseText)},er.open(\"POST\",sv,!0),er.withCredentials=true,er.send(d),er},l(\"h_json=\"+1*(\"JSON\"in s&&void 0!==JSON.parse)+\"&h_wc=1&h_event=\"+1*(\"addEventListener\"in s)+\"&sva=\"+e)}catch(x){s=new Image,s.src=\"//salesviewer.org/tle.gif?sva=LE-003992-002&e=\"+encodeURIComponent(x)}}(window,\"XDomainRequest\",\"XMLHttpRequest\",\"LE-003992-002\")" +
                             "</script>";
  document.body.innerHTML = document.body.innerHTML + strSalesViewerScript;

  var strSalesViewerNoScript = "<noscript><img src=\"//salesviewer.org/LE-003992-002.gif\" style=\"visibility:hidden;\" /></noscript>";
  document.body.innerHTML = document.body.innerHTML + strSalesViewerNoScript;

  // <!-- End SalesViewer® -->
}
*/



// -------------------------------------------------------------------------------------------------------
// Build up URL to Shop:
//
// This url 
//      https://shop.ktr.com/sap(bD1kZSZjPTAxMA==)/bc/bsp/sap/z_in_webchannel/main.do?zkon=1%24550147101400%7c1%24020141000045%7c1%24550147101600
//
// will result in this partlist in shopping cart
//
// 1	550147101400	1	 ROTEX GS 14 AL-H	 Nabe 1.0 Ø14H7 Nut DIN 6885/1-JS9	13,65 EUR
// 2	020141000045	1	 ROTEX 14	         Zahnkranz 92 Sh-A =T-PUR®= orange	2,95 EUR
// 3	550147101600	1	 ROTEX GS 14 AL-H	 Nabe 1.0 Ø16H7 Nut DIN 6885/1-JS9	13,65 EUR
//
// These are the particular parts of the url parameter:
//
// https://shop.ktr.com/sap(bD1kZSZjPTAxMA==)/bc/bsp/sap/z_in_webchannel/main.do?
// zkon=
// 1
// %24
// 550147101400
// %7c
// 1
// %24
// 020141000045
// %7c
// 1
// %24
// 550147101600
//
// That is, a partlist is like  zkon=<num>$<matnr>|<num>$<matnr> ...
// URL-Decoded values:  %24 --> $ , %7c  --> |
export function createShopUrl(partlist: string[]) {
    //var url = "http://sap02m.ktr.ad:8000/sap(bD1kZSZjPTAxMA==)/bc/bsp/sap/z_in_webchannel/main.do?zkon="
    //var url = "https://shop.ktr.com/sap(bD1kZSZjPTAxMA==)/bc/bsp/sap/z_in_webchannel/main.do?zkon=";      //
    //var url = "https://shop.ktr.com/shop(bD1kZSZjPTAxMA==)/main.do?zkon=";
    var url = "https://shop.ktr.com/shop/entry?zkon=";

    var anzahl = 1;
    var isFirstMatNr = true;
    partlist.forEach(function(matnr) {
        if(matnr.length > 0) {
            if(isFirstMatNr ===true) {
                isFirstMatNr = false;
            }
            else {
                url = url + "%7c";
            }
            url = url + anzahl + "%24";
            url = url + matnr;
        }
    });

    return url;
}


